import React from "react";
import { Link } from "react-router-dom";
import "../Css/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <>
      {/* HERO SECTION */}

      <section className="privacy-hero">
        <div className="privacy-overlay">
          <div className="privacy-hero-content">
            <h1>Privacy Policy</h1>

            <p>
              <Link to="/">Home</Link> /{" "}
              <span className="active">Privacy Policy</span>
            </p>
          </div>
        </div>
      </section>

      {/* CONTENT */}

      <section className="privacy-page">

        <div className="privacy-container">

          <p className="last-updated">
            Last Updated: {new Date().getFullYear()}
          </p>

          <p>
            Tanya Maid Service values your privacy and is committed to protecting
            your personal information. This Privacy Policy explains how we
            collect, use, and safeguard the information you provide when using
            our website.
          </p>

          <h2>Information We Collect</h2>

          <p>
            When you contact us through our website, we may collect personal
            information such as your name, phone number, email address, and
            service requirements.
          </p>

          <h2>How We Use Your Information</h2>

          <ul>
            <li>To respond to inquiries and service requests</li>
            <li>To provide maid services and customer support</li>
            <li>To improve our website and services</li>
            <li>To communicate important service updates</li>
          </ul>

          <h2>Information Protection</h2>

          <p>
            We take appropriate security measures to protect your personal
            information from unauthorized access, misuse, or disclosure.
          </p>

          <h2>Sharing of Information</h2>

          <p>
            Tanya Maid Service does not sell, trade, or rent users’ personal
            information to third parties. Your information is only used for
            service-related communication.
          </p>

          <h2>Third-Party Links</h2>

          <p>
            Our website may contain links to third-party websites such as
            Google or social media platforms. We are not responsible for the
            privacy practices of those websites.
          </p>

          <h2>Cookies</h2>

          <p>
            Our website may use cookies to improve user experience and analyze
            website traffic.
          </p>

          <h2>Changes to This Policy</h2>

          <p>
            We may update this Privacy Policy occasionally. Any changes will be
            posted on this page.
          </p>

          <h2>Contact Us</h2>

          <p>
            If you have any questions regarding this Privacy Policy, you may
            contact us:
          </p>

<ul className="contact-info">

<li>Phone :<a href="tel:+917304398067"> +91 73043 98067</a></li>

<li>Email : <a href="mailto:info@tanyamaidservice.com"> info@tanyamaidservice.com</a></li>

<li>Address : <a href="https://maps.google.com/?q=Block+No.317+Rajasthan+Compound+Western+Express+Highway+Goregaon+East+Mumbai+63" target="_blank" rel="noopener noreferrer"> Block No.317, Rajasthan Compound, Western Express Highway, Near Virwani Industrial Estate, Goregaon (E), Mumbai-63</a></li>

</ul>

        </div>

      </section>
    </>
  );
};

export default PrivacyPolicy;